import moment from 'moment';
import { parse } from '../utils/parse';
import { separate } from '../utils/strings/separate';

export interface DateIntervalType {
    d: number;
    f: number;
    h: number;
    i: number;
    m: number;
    s: number;
    y: number;
    days: boolean;
    first_last_day_of: number;
    have_special_relative: number;
    have_weekday_relative: number;
    invert: number;
    special_amount: number;
    special_type: number;
    weekday: number;
    weekday_behavior: number;
}

export const getDefaultInterval = (): DateIntervalType => ({
    d: 0,
    f: 0,
    h: 0,
    i: 0,
    m: 0,
    s: 0,
    y: 0,
    days: false,
    first_last_day_of: 0,
    have_special_relative: 0,
    invert: 0,
    have_weekday_relative: 0,
    special_amount: 0,
    special_type: 0,
    weekday: 0,
    weekday_behavior: 0,
});

export const toDateInterval = (value: string | DateIntervalType): DateIntervalType => {
    if (typeof value === 'string') {
        const defaultValue = getDefaultInterval();
        const duration = moment.duration(...(separate(value, ' ').map(parse) as any));

        defaultValue.d = duration.asDays();

        return defaultValue;
    }

    return value;
};
